import { Component, inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SicotService } from '../../sicot.service';
import { FhirTaskStatus } from '../../types/OperationStatus';
import { CommonModule } from '@angular/common';

export interface StatoFhirDialogData {
  operationId: string;
}

@Component({
  selector: 'app-stato-fhir-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './stato-fhir-dialog.component.html',
  styleUrl: './stato-fhir-dialog.component.css',
})
export class StatoFhirDialogComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<StatoFhirDialogComponent>);
  private readonly data = inject<StatoFhirDialogData>(MAT_DIALOG_DATA);
  private readonly sicot = inject(SicotService);

  operationId: string = this.data.operationId;
  task: FhirTaskStatus | null = null;
  loading = true;
  error: string | null = null;
  showRawJson = false;

  ngOnInit(): void {
    this.sicot.getRichiestaValutazioneStatus(this.operationId).subscribe({
      next: (t) => {
        this.task = t;
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.message ?? err?.statusText ?? 'Errore nel caricamento dello stato.';
        this.loading = false;
      },
    });
  }

  get statusLabel(): string {
    if (!this.task) return '—';
    const status = this.task.extension?.find(e => e.url?.includes('operationStatus'))?.valueString ?? this.task.status;
    const map: Record<string, string> = {
      'PENDING': 'In attesa',
      'RUNNING': 'In elaborazione',
      'SUCCEEDED': 'Completata',
      'FAILED': 'Fallita',
    };
    return map[status] ?? status;
  }

  get errorMessage(): string | undefined {
    const ext = this.task?.extension?.find(e => e.url?.includes('operationErrorMessage'));
    return ext?.valueString ?? undefined;
  }

  get rawJson(): string {
    return this.task ? JSON.stringify(this.task, null, 2) : '';
  }

  chiudi(): void {
    this.dialogRef.close();
  }
}
